export enum ORDER_PROPOSAL_STATUS {
	Waiting = 0,
	Accepted = 1,
	Refused = 2,
}
